export default __webpack_public_path__ + "static/grid-align-figma-do-0e3dd6dd82341e6d0e0552e5a9003b4da074b43308281c1257100f84eaf8dfd0.png";